export default __webpack_public_path__ + "static/media/3gameMode.d36f1c3e.gif";